@if (coverageTab && coverageFormGroup && !isNotConfigured) {
  <div>
    @if (coverageTab.showCalcedTierSelectionGrid) {
      <div class="mb-3 message-card">
        <mwp-text-translate text="The toggles under the Add/Term column will allow you to add or terminate members for the current benefit. Click on the toggle next to the name of the member you would like to adjust. If the label says &quot;Required&quot; next to a member's name, that member is required to have coverage under the plan and may not be modified. If you do not wish to modify a currently unenrolled member, you do not need to click on any of the toggles." jsonKey="coverageCheckBoxNote" />
      </div>
    }
    <div class="content-container">
      <form [formGroup]="coverageFormGroup">
        @if (displayGenericBenefitOptions) {
          <div class="title">
            {{coverageBenefitName}}
          </div>
          <div class="content">
            @if (coverageTab.currentCoverage) {
              <div id="currentCoverage" class="mb-3">
                <div class="d-inline-flex">
                  <div class="me-2 fw-bold">
                    {{coverageTab.currentCoverageForDisplay}}:
                  </div>
                  <div>
                    {{coverageTab.currentCoverage}}
                  </div>
                </div>
              </div>
            }
            @if (coverageTab.currentRate) {
              <div id="currentRate" class="mb-3">
                <div class="d-inline-flex">
                  <div class="me-2 fw-bold">
                    {{coverageTab.currentRateForDisplay}}:
                  </div>
                  <div>
                    {{coverageTab.currentRate}}
                  </div>
                </div>
              </div>
            }
            @if (coverageTab.showActiveAtWork) {
              <div id="showActiveAtWork" class="mb-3">
                <mwp-button-toggle [form]="coverageFormGroup" [nameForControl]="isActiveAtWorkName" [dataEnum]="booleanEnum" [label]="coverageTab.activeAtWorkLabelForDisplay" />
              </div>
            }
            @if (coverageTab.showYesKnockout) {
              <div id="showYesKnockout" class="mb-3">
                <mwp-button-toggle [form]="coverageFormGroup" [nameForControl]="isYesKnockoutName" [dataEnum]="booleanEnum" [label]="coverageTab.yesKnockoutLabelForDisplay" />
              </div>
            }
            @if (coverageTab.showPayrollTaxStatus) {
              <div id="showPayrollTaxStatus" class="mb-3">
                @if (displayChangingTaxStatusOnly) {
                  <div class="mb-2">
                    <mat-checkbox [formControlName]="changingTaxStatusOnlyName">
                      <mwp-text-translate text="Check here if you only want to change the tax status of the benefit." jsonKey="coverageCheckbox" />
                    </mat-checkbox>
                  </div>
                }
                <mwp-button-toggle [form]="coverageFormGroup" [nameForControl]="isPretaxStatusName" [dataEnum]="taxStatus" [label]="taxStatusQuestion" />
              </div>
            }
            @if (coverageTab.showEnrollmentReason) {
              <div id="showEnrollmentReason" class="mb-3">
                <mwp-benefit-enrollment-wizard-coverage-enrollment-reason [coverageFormGroup]="coverageFormGroup" [coverageTab]="coverageTab">
                </mwp-benefit-enrollment-wizard-coverage-enrollment-reason>
              </div>
            }
            @if (coverageTab.showFlatTier) {
              <div id="showFlatTier" class="mb-3">
                <div class="d-inline-flex ">
                  <div class="me-2 fw-bold">
                    {{coverageTab.flatTierLabelForDisplay}}:
                  </div>
                  <div>
                    {{coverageTab.flatTierValue}}
                  </div>
                </div>
              </div>
            }
            @if (coverageTab.showManualCoverage) {
              <div id="showManualCoverage" class="col-4 mb-3">
                <mwp-input [form]="coverageFormGroup" [labelName]="coverageTab.manualCoverageLabelForDisplay" [nameForControl]="manualCoverageValueName" [maskType]="maskType.currency" />
              </div>
            }
            @if (coverageTab.showCoveredMember) {
              <div id="showCoveredMember" class="mb-3">
                <div class="d-inline-flex">
                  <div class="me-2 fw-bold">
                    <mwp-text-translate text="Covered Member:" jsonKey="coverageCoveredMember" />
                  </div>
                  <div>
                    {{coverageTab.coveredMemberForDisplay}}
                  </div>
                </div>
              </div>
            }
            @if (coverageTab.showCoverageDropdown) {
              <div id="showCoverageDropdown" class="col-4 mb-3">
                <mwp-dropdown [form]="coverageFormGroup" [labelName]="$safeNavigationMigration(coverageTab?.coverageDropdownLabelForDisplay)" [nameForControl]="coverageDropdownValueName" [data]="coverageTab.coverageDropdownCollection" [isListItemArray]="true" (emitSelected)="reloadTierGrid($event)" />
              </div>
            }
            @if (coverageTab.showManualRate) {
              <div id="showManualRate" class="col-4 mb-3">
                <mwp-input [form]="coverageFormGroup" [labelName]="coverageTab.manualRateLabelForDisplay" [nameForControl]="manualRateValueName" [maskType]="maskType.currency" />
              </div>
            }
            @if (this.coverageTab.showMiscDeductionCoverage) {
              <div id="showMiscDeductionCoverage" class="mb-3">
                @if (this.coverageTab.showMiscDeductionCoverageWarning) {
                  <div class="mb-3">
                    {{ this.coverageTab.miscDeductionWarningLabelForDisplay }}
                  </div>
                }
                <div class="col-6">
                  <mwp-input [form]="coverageFormGroup" [labelName]="coverageTab.miscDeductionCoverageLabelForDisplay" [nameForControl]="miscDedCoverageValueName" [maskType]="maskType.currency" />
                </div>
              </div>
            }
          </div>
          @if (displayAddDependentButton) {
            <div id="displayAddDependentButton" class="footer d-flex justify-content-end w-100 p-3">
              <button class="mwp-button-save" (click)="openDependentDialog()">
                <mwp-text-translate text="Add Dependent" jsonKey="addDependent" />
              </button>
            </div>
          }
        }
        @if (coverageTab.showHsaOption) {
          <div id="showHsaOption" class="mb-3">
            <mwp-benefit-enrollment-wizard-coverage-hsa [coverageFormGroup]="coverageFormGroup" [coverageTab]="coverageTab" />
          </div>
        }
        @if (coverageTab.showFsaOption) {
          <div id="showFsaOption" class="mb-3">
            <mwp-benefit-enrollment-wizard-coverage-fsa [coverageFormGroup]="coverageFormGroup" [coverageTab]="coverageTab" />
          </div>
        }
        @if (coverageTab.showCalcedTierSelectionGrid) {
          <div id="showCalcedTierSelectionGrid" class="mb-3">
            <mwp-benefit-enrollment-wizard-coverage-calced-tier-selection-grid [coverageFormGroup]="coverageFormGroup" [coverageTab]="coverageTab" [coverageArrayName]="calcedTierGroupName" [showAddDependentButton]="coverageTab.showAddDependent" (emitReload)="reload()" />
          </div>
        }
      </form>
      <div class="footer">
        <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="!coverageFormGroup.valid" (emitComplete)="submitCoverage()" />
      </div>
    </div>
  </div>
}
@if (isNotConfigured) {
  <mwp-wizard-error [errorPanelName]="panelName" />
}